<script>
import { Line, mixins } from 'vue-chartjs';
import chartjsPluginAnnotation from 'chartjs-plugin-annotation';
import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default {
    name: 'SalaryIncomeChart',
    extends: Line,
    mixins: [mixins.reactiveProp],
    props: ['chartData', 'options'],
    mounted() {
        Chart.plugins.unregister(ChartDataLabels);
        this.addPlugin(chartjsPluginAnnotation);
        this.renderChart(this.chartData, this.options);
    },
};
</script>
